export default __webpack_public_path__ + "static/media/Calendar.74e4a02c.svg";